import React from 'react';
import { Box, Stack, Typography } from '@mui/joy';
import type { IconType } from 'react-icons';
import { IconWrapper } from './IconWrapper';

/**
 * Shared header for workspace stage cards: icon + title + helper on one indent,
 * optional action on the right.
 */
export function WorkspaceCardHeader({
  icon,
  title,
  description,
  action,
  sx,
}: {
  icon: IconType;
  title: string;
  description?: string;
  action?: React.ReactNode;
  sx?: Record<string, unknown>;
}) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={1}
      sx={{ mb: description ? 1.25 : 1, ...sx }}
    >
      <Stack direction="row" alignItems="flex-start" gap={1} sx={{ minWidth: 0, flex: 1 }}>
        <Box
          sx={{
            color: 'primary.500',
            display: 'flex',
            mt: 0.25,
            width: 20,
            flexShrink: 0,
            justifyContent: 'center',
          }}
        >
          <IconWrapper icon={icon} />
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography level="title-md">{title}</Typography>
          {description ? (
            <Typography level="body-xs" sx={{ color: 'neutral.500', mt: 0.25 }}>
              {description}
            </Typography>
          ) : null}
        </Box>
      </Stack>
      {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
    </Stack>
  );
}
